// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Nunito_ff4b98', '__Nunito_Fallback_ff4b98'","fontStyle":"normal"},"className":"__className_ff4b98"};